export enum EParcelType {
  None = 0,
  EDelivery = 1,
  EncryptedEDelivery = 2,
  NotaEncrypted = 4,
  Email = 8,
  ExternalEDelivery = 16,
  Puh = 32,
  Epuap = 64,
  /** Elektroniczne Biuro Interesanta — adresat z PESEL-em, awizo e-mailem. */
  Ebi = 128,
  TraditionalLetter = 256,
  CourtPortalWriting = 512,
  ContactMessage = 1024,
}
